/**
 * Setting path constants for loss prevention feature management
 * Used with updateSetting() to avoid magic strings
 */
export const SETTING_PATHS = {
  isEnabled: 'isEnabled',
  knownAddress: {
    enabled: 'knownAddress.enabled',
  },
  rushShipping: {
    enabled: 'rushShipping.enabled',
  },
  unusualOrderTime: {
    enabled: 'unusualOrderTime.enabled',
    startHour: 'unusualOrderTime.startHour',
    endHour: 'unusualOrderTime.endHour',
  },
  highValueThreshold: {
    enabled: 'highValueThreshold.enabled',
    orderValueThresholdUsd: 'highValueThreshold.orderValueThresholdUsd',
    maxPreviousOrders: 'highValueThreshold.maxPreviousOrders',
  },
  velocityAlerts: {
    enabled: 'velocityAlerts.enabled',
    maxOrdersPerAddress: 'velocityAlerts.maxOrdersPerAddress',
    timeWindowHours: 'velocityAlerts.timeWindowHours',
  },
  addressBlacklist: {
    enabled: 'addressBlacklist.enabled',
    enableFuzzyMatching: 'addressBlacklist.enableFuzzyMatching',
    fuzzyFlagThreshold: 'addressBlacklist.fuzzyFlagThreshold',
    fuzzyBlockThreshold: 'addressBlacklist.fuzzyBlockThreshold',
  },
  internationalAddressMismatch: {
    enabled: 'internationalAddressMismatch.enabled',
  },
} as const;

/**
 * Shared dropdown options used by multiple cards
 */
export const MAX_ORDERS_OPTIONS = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '10', label: '10' },
];

/**
 * Fuzzy matching threshold constraints
 */
export const FUZZY_THRESHOLD = {
  MIN_GAP: 5,
  FLAG_MIN: 1,
  FLAG_MAX: 95,
  BLOCK_MIN: 6,
  BLOCK_MAX: 100,
} as const;
